// src/vatandas/components/VatandasLayout.js
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import VatandasNavbar from "./VatandasNavbar";
import VatandasFooter from "./VatandasFooter";

import "./VatandasLayout.css";
import "../styles/vatandas-style.css";

const VatandasLayout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    document.body.classList.add("vatandas-body");
    return () => document.body.classList.remove("vatandas-body");
  }, []);

  // Not: Home route’unuz farklıysa burayı ona göre güncelleyin
  const isHome = location.pathname === "/" || location.pathname === "/anasayfa";

  return (
    <div className="layout-container vatandas-theme">
      <VatandasNavbar />

      <main className={`content ${isHome ? "content--fullbleed" : ""}`} role="main">
        {children}
      </main>

      <VatandasFooter />
    </div>
  );
};

export default VatandasLayout;
